if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute('available')) return;

      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith('/')) {
        rootUrl = rootUrl + '/';
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.updateAvailability(sectionInnerHTML);
        })
        .catch((error) => {
          console.error('Error fetching availability:', error);
          this.renderError();
        });
    }

    updateAvailability(sectionInnerHTML) {
      console.log('updateAvailability called');

      const availabilityInfo = sectionInnerHTML.querySelector('.pickup-availability-information');
      if (!availabilityInfo) {
        console.log('No availability information found');
        this.innerHTML = '';
        this.removeAttribute('available');
        return;
      }

      // Use the existing button from the Liquid code
      this.innerHTML = availabilityInfo.innerHTML;
      this.setAttribute('available', '');

      const button = this.querySelector('.pickup-availability-information__button');
      let availableLocationId = button ? button.getAttribute('data-location-id') : null;

      // Fallback check for available location ID
      if (!availableLocationId) {
        const locationElement = sectionInnerHTML.querySelector('.pickup-availability-information__button');
        availableLocationId = locationElement ? locationElement.getAttribute('data-location-id') : null;
      }

      console.log('Available Location ID:', availableLocationId);

      const locations = {
        "96556712270": {
          name: "Queensbury",
          address: "Cheap Furniture Warehouse, Victoria Mill, Black Dyke Mills, Old Mill Dam Ln, Queensbury, Bradford BD13 1QA"
        },
        "98004271438": {
          name: "Shipley",
          address: "Cheap Furniture Warehouse, Ashley Ln, Shipley, BD17 7DB, UK"
        }
      };

      const locationData = locations[availableLocationId];

      if (locationData) {
        console.log('Location data found:', locationData);

        // Update the existing button's URL directly
        const encodedAddress = encodeURIComponent(locationData.address);
        const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;

        if (button) {
          button.href = directionsUrl;
          button.target = '_blank';
          button.textContent = `Get Directions to ${locationData.name}`;
          console.log('Updated existing button with directions link');
        }

        // Update the pickup availability message
const pickupMessage = this.getPickupMessage();
const stockElement = this.querySelector('.pickup-availability-information__stock');
if (stockElement) {
  stockElement.innerHTML = pickupMessage; // Use innerHTML instead of textContent
  console.log('Updated pickup availability message:', pickupMessage);
}

      } else {
        console.log('No location data found for the given ID');
      }
    }

    // Function to determine the pickup availability message based on current time
getPickupMessage() {
  const now = new Date();
  const day = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const hour = now.getHours();

  // Helper function to get the name of the day
  const getDayName = (dayIndex) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[dayIndex];
  };

  // Rule 1: Weekend or outside business hours (Friday 3 PM - Monday 9 AM)
  if ((day === 5 && hour >= 15) || day === 0 || (day === 6 && hour >= 15) || (day === 1 && hour < 9)) {
    return "Available for pickup on <strong>Monday</strong> from <strong>12 PM</strong>";
  }

  // Rule 2: After business hours on a workday (Monday - Thursday after 3 PM)
  if ((day >= 1 && day <= 4) && hour >= 15) {
    return "Available for pickup <strong>tomorrow</strong> from <strong>12 PM</strong>";
  }

  // Rule 3: Before business hours on a workday (Monday - Saturday before 10 AM)
  if ((day >= 1 && day <= 6) && hour < 10) {
    return "Available for pickup <strong>today</strong> after <strong>12 PM</strong>";
  }

  // Default message during working hours (Monday - Saturday, 10 AM - 3 PM)
  return "Available for pickup in <strong>2 hours</strong>";
}

    renderError() {
      this.innerHTML = '<p>Pickup availability information could not be loaded.</p>';
      console.log('Rendered error message');
    }
  });
}
